

























import { Component, Vue } from "vue-property-decorator";
import { store, StoreState } from "../store";
import { mapState } from 'vuex';
import Sidebar from '../components/Sidebar.vue';
import Panel from '../components/conference/Panel.vue';
import StartCall from '../components/conference/StartCall.vue';
import Schedule from '../components/conference/Schedule.vue';
import Bridge from '../components/conference/Bridge.vue';
import AES from "crypto-js/aes";
import CryptoJS from "crypto-js";
@Component({
    components: {
        Sidebar,
        Panel,
        StartCall,
        Schedule,
        Bridge
    },
    
    computed: {
			...mapState({
                 userfirstname: (state: StoreState) => state.dashboard.userfirstname,
            })
        },
})
export default class Conference extends Vue {
  data() {
    return {
      // renderComponent: 'Bridge',
      isBridge: true,
      toStartCall: false,
      toSchedule: false,
      toBridge: true,
    };
  }

  async created() {
    await this.$store.dispatch('getConferenceUsers');
  }

  handleClose() {
    this.$data.toStartCall = false,
    this.$data.toSchedule = false,
    this.$data.toBridge = true
  }

 get loger_Name(){   
			this.$data.notifications_open = true;
			var Login_User=AES.decrypt(decodeURI((this as any).$cookies.get('username')),"2r5u8x/A").toString(CryptoJS.enc.Utf8);
			Login_User=Login_User.substring(0,Login_User.indexOf('@'));
			return Login_User
        }
  handleClicked(renderComp) {
    switch (renderComp) {
      case 'Bridge':
        this.$data.toStartCall = false,
        this.$data.toSchedule = false,
        this.$data.toBridge = true
        break;
      case 'StartCall':
        (this as any).$children[2].closingModal();
        this.$data.toStartCall = true,
        this.$data.toSchedule = false,
        this.$data.toBridge = false
        break;
      case 'Schedule':
        this.$data.toStartCall = false,
        this.$data.toSchedule = true,
        this.$data.toBridge = false
        break;
    }
    // this.$data.renderComponent = renderComp;
  }
}
